import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

/** País por defecto del selector de teléfono (ISO-3166-1 alpha-2). */
export const DEFAULT_PHONE_COUNTRY = 'ES';

/**
 * Deriva el país (ISO-2, p.ej. 'ES', 'GB') de un teléfono en formato E.164
 * (+34...). Devuelve '' si no se puede determinar o el valor está vacío.
 */
export function countryFromPhone(phone) {
  if (!phone) return '';
  try {
    return parsePhoneNumber(String(phone))?.country || '';
  } catch {
    return '';
  }
}

/**
 * Teléfono OPCIONAL en el alta de socio (muchos socios extranjeros no lo dan).
 * - Vacío/undefined → válido (no es un impedimento para dar de alta).
 * - Si se proporciona, debe ser válido para su país en formato internacional (E.164).
 */
export function isValidSocioPhone(phone) {
  if (!phone || !String(phone).trim()) return true;
  return isValidPhoneNumber(String(phone));
}
